import { useRouter } from '@edreamsodigeo/frontend-core';
import { usePriceFreezeSession, SB_ID } from '@/hooks/usePriceFreezeSession';
import { useCallback, useMemo } from 'react';

export const HOME = 'pfhome';
export const OFFERS = 'pfoffers';
export const PAX = 'pfpax';
export const PAYMENT = 'pfpayment';
export const CONFIRMATION = 'pfconfirmation';

const PAGES = {
  [HOME]: {
    url(params = {}) {
      return `${HOME}/${params.searchId}/${params.fareItineraryKey}/${params.segmentKeys}/`;
    },
  },
  [OFFERS]: {
    url(params = {}) {
      return `${OFFERS}/${params.searchId}/${params.fareItineraryKey}/${params.segmentKeys}/${params.shoppingId}/`;
    },
  },
  [PAX]: {
    url(params = {}) {
      return `${PAX}/${params.searchId}/${params.fareItineraryKey}/${params.segmentKeys}/`;
    },
  },

  [PAYMENT]: {
    url(params = {}) {
      return `${PAYMENT}/${params.searchId}/${params.fareItineraryKey}/${params.segmentKeys}/${params.shoppingId}/`;
    },
  },
  [CONFIRMATION]: {
    url(params) {
      return `${CONFIRMATION}/${params.searchId}/${params.fareItineraryKey}/${params.segmentKeys}/`;
    },
  },
};

export function usePriceFreezeRouter() {
  const router = useRouter();
  const [getSessionItem] = usePriceFreezeSession();

  const navigateTo = useCallback(
    (page) => {
      if (PAGES[page]) {
        router.push(
          PAGES[page].url({
            ...router.query,
            shoppingId: getSessionItem(SB_ID),
          })
        );
      }
    },
    [router, getSessionItem]
  );

  return useMemo(
    () => ({
      navigateTo,
      back: router.back,
    }),
    [navigateTo, router.back]
  );
}
